const horaire223 = {
    'mondayOpen': '',
    'mondayClose': '',
    'tuesdayOpen': '',
    'tuesdayClose': '',
    'wednesdayOpen': '',
    'wednesdayClose': '',
    'thursdayOpen': '',
    'thursdayClose': '',
    'fridayOpen': '',
    'fridayClose': '',
    'saturdayOpen': '',
    'saturdayClose': '',
    'sundayOpen': '',
    'sundayClose': '',
};

export default horaire223;
